"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SweatEmAbilityHandler = exports.SweatEmActorAbilityFactory = exports.SweatEmAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SweatEmAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SweatEm;
        this.__typeName = "SweatEm";
    }
}
exports.SweatEmAbilityArgs = SweatEmAbilityArgs;
let SweatEmActorAbilityFactory = class SweatEmActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SweatEm", "AllEnemies", 2);
    }
};
SweatEmActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SweatEm")
], SweatEmActorAbilityFactory);
exports.SweatEmActorAbilityFactory = SweatEmActorAbilityFactory;
let SweatEmAbilityHandler = class SweatEmAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: targets.map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                type: "MagicCard",
                path: "line",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 50)
                ]
            })),
            sequence,
            onHit(sequence, _attack, _damagers, projectile) {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(projectile.targetId), "PurpleExplosion"));
            },
        });
        const target = container.testAttribute(ability.invokerId, "Luck", 25) ? Target_1.Target.AllEnemies
            : Target_1.Target.AllAllies;
        const stacks = (0, Random_1.random)(1, 10);
        const debuffsSequence = sequence.pushSequence("parallel");
        for (const targetId of container.selectLivingTargets(ability.invokerId, target)) {
            container.applyDebuff({
                attackerId: ability.invokerId,
                targetId: targetId,
                effect: new __1.SlowEffectArgs(stacks),
                duration: Duration_1.Duration.Turns(4),
                sequence: debuffsSequence.pushSequence("sequential"),
            });
        }
    }
};
SweatEmAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SweatEm)
], SweatEmAbilityHandler);
exports.SweatEmAbilityHandler = SweatEmAbilityHandler;
